import { render, staticRenderFns } from "./ClueManagement.vue?vue&type=template&id=d62c200c"
import script from "./ClueManagement.vue?vue&type=script&lang=js"
export * from "./ClueManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports